import { ref, inject, reactive,nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Vrouter from '@/router'
import { Toast } from 'vant'
import {useStore} from '@/main'
interface LoginInfo {
  access_token: string,
  kong_access_token: string,
  refresh_token: string
}
let router:any = Vrouter;
let store:any = {}

nextTick(()=>{
  store = useStore()
})
const loginFn = async function (loginData: LoginInfo, $http: any, register?: string) {
  let { data } = await $http.setToken(loginData.access_token).setKongToken(loginData.kong_access_token).profile()
  if (data) {
    store.setToken(loginData.access_token)
    store.setKongToken(loginData.kong_access_token)
    store.setRefreshToken(loginData.refresh_token)
    // this.$cookies.set('access_token', token,{
    //     path: '/',
    //     maxAge: 60 * 60 * 24 * 7
    //   })
    // this.$cookies.set('user', data,{
    //     path: '/',
    //     maxAge: 60 * 60 * 24 * 7
    //   })
    store.setUserInfo(data)

    // url地址携带回掉参数
    if(router.currentRoute && router.currentRoute.value && router.currentRoute.value.query && router.currentRoute.value.query.refer) {
      router.push(router.currentRoute.value.query.refer)
      return
    }
    
    // this.$store.commit('user', data) ----------------------
   if(!register&&common.getStorage('redirect_url')) {
      router.push(common.getStorage('redirect_url'));
        common.delStorage('redirect_url')
        return 
   }
    if (register == 'register') {
      router.push('/');
    }
    else if (register == 'bind') {
      router.push('/findPwd?type=bind');
    } else {
      // 不是app进入,且不是外部链接进入的情况下会回到home页面
      if(navigator.userAgent.indexOf("kilimall,android") <= -1&&!common.getStorage('isExLink')) { 
        router.push('/home');
      }
      // router.replace( route.query.refer ? String(route.query.refer).replace('/home','') : '/account/orders' )
    }

  }
}
async function CommonLogin(para: object, $http: any, type?: string) {
  let ret = await $http.login(para)
  if (ret.code == 200) {
    if (!ret.data.email && !ret.data.phone) {
      loginFn(ret.data, $http, 'bind');
    } else {
      loginFn(ret.data, $http,'');
    }
  } else if (ret.code == 402) {
    if (type == 'login') {
      Toast(ret.message);
    } else {
      router.push('/login?type=register') // 还未注册
    }
  } else {
    Toast(ret.message);
  }
  return ret
}

async function refreshTokenApi($http: any) {
  const router = useRouter()
  let params = {
    refresh_token: common.getStorage('refresh_token')
  }
  let res = await $http.oauthToken(params)
  if (res.data && res.data.access_token) {
    let expiresDay = res.data.expires_in ? (res.data.expires_in / 86400 - 7) : 15
    store.setToken(res.data.access_token, expiresDay)
    store.setKongToken(res.data.kong_access_token, expiresDay)
    let token_obj:any = {
      access_token:res.data.access_token,
      refresh_token:res.data.refresh_token,
      kong_access_token:res.data.kong_access_token

    }
    store.setRefreshToken(res.data.refresh_token, expiresDay)
    loginFn(token_obj, $http, '');
  } else {
    common.delStorage('key')
    common.delStorage('username')
    common.delStorage('access_token')
    common.delStorage('kong_access_token')
    common.delStorage('refresh_token')
    router.push('/login')
  }
}

/**
 * 退出登陆
 */
function logoutFn($http: any) {
  common.delStorage('key')
  common.delStorage('username')
  common.delStorage('access_token')
  common.delStorage('kong_access_token')
  common.delStorage('refresh_token')
  common.delStorage('user_info')
  $http.clearToken()
  router.replace('login')
}
export {
  loginFn,
  CommonLogin,
  refreshTokenApi,
  logoutFn
}

